var module = angular.module('meternet.about.services', []);

module.service('aboutService', function (dataService) {

});
